module.exports = __webpack_public_path__ + "img/微信logo.69425eea.png";